module.exports = __webpack_public_path__ + "static/ForTheKing2-1b2001bf6be867e6c6bfcbeaf56485dc.webp";